import { Action } from "..";
import { LasServiceBase } from "../../types/lasServiceBase";

export const LAS_SERVICE_CHANGE = "LAS_SERVICE_CHANGE";

export function setLasService(lasService: LasServiceBase): Action {
  return { type: LAS_SERVICE_CHANGE, payload: lasService };
}
